/**
 * 교통선 컴포넌트
 * 
 * 주요 기능:
 * 1. 도로 교통 상태 시각화
 * 2. 속도에 따른 색상 구분
 *   - 원활: 초록색
 *   - 서행: 주황색
 *   - 정체: 빨간색
 * 3. 마우스 오버/아웃 효과
 * 
 * 데이터 처리:
 * - mapApi.getGeo: 도로 정보 및 교통 상태 데이터
 * 
 * 상태 관리:
 * - mapParamState: 지도 파라미터 (경계값, 줌 레벨)
 * 
 * 상호작용:
 * - 마우스 오버: 선 두께 증가, 투명도 증가
 * - 마우스 아웃: 원래 스타일 복원
 * - 클릭: 도로 정보 표시 및 상태 업데이트
 */
import React, { useEffect, useMemo, useState } from "react";
import CustomPolyline from "./CustomPolyline";
import { useRecoilState, useRecoilValue } from "recoil";
import { mapParamState, polyLineClickState } from "../../../atoms";
import { useQuery } from "react-query";
import { mapApi } from "../../../api/mapApi";

const TrafficLine = () => {
  const [trafficLine, setTrafficLine] = useState<any>([]);
  const param = useRecoilValue(mapParamState);
  const [polyLineClick, setPolyLineClick] = useRecoilState(polyLineClickState);
  const polyLineInitial = useMemo(
    () => ({
      position: {
        lat: 0,
        lng: 0,
      },
      linkId: "",
      roadName: "",
      speed: 0,
      maxSpeed: 0,
    }),
    [],
  );
  const { data } = useQuery(["getGeo", param], () => mapApi.getKakaoGeo(param));

  useEffect(() => {
    // console.log("✅ main map data", data);
    if (data) {
      if (
        polyLineClick &&
        !data.some((item: any) => item.linkId === polyLineClick.linkId)
      ) {
        setPolyLineClick(polyLineInitial);
      }
      const polyLineArr = data.map((item: any, index: number) => (
        <CustomPolyline item={item} index={index} key={index} />
      ));
      setTrafficLine(polyLineArr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return trafficLine;
};

export default TrafficLine;
